module.exports = __webpack_public_path__ + "img/pic_category_02_w1200.f707472b.png";